export default "__VITE_PUBLIC_ASSET__30196444__"